import { emptyObject } from 'ui-components/default-props/empty';
import { baseReducer as BaseReducer } from '../../../store/core/base-reducer';
import * as Actions from './batches.nav.actions';
import * as BasicBatchActions from '../batches.actions';

const initialState = {
  detailsFulfillmentPlanSetId: '',
  showDetails: false,
  hasFetchedActiveBatches: false,
  myBatches: emptyObject,
  otherBatches: emptyObject,
  isMenuOpen: true,
  isLoading: false,
  pageSize: 25,
};

const normalizeBatches = (batches) =>
  batches.reduce((dict, datum) => {
    const { fulfillmentPlanSetId } = datum;
    return {
      ...dict,
      [fulfillmentPlanSetId]: datum,
    };
  }, {});

const handleBatchMenuSuccess = (state, { batchData, currentUserId }) => {
  const { pageData, totalCount } = batchData;
  // Because chrome fails to implement the spec for object iterable ordering we cover ourselves with the sort index
  const batchesWithSortIndex = pageData.map((datum, index) => ({
    ...datum,
    sortIndex: index,
  }));
  const myBatches = batchesWithSortIndex.filter(({ assignedToGuid }) => assignedToGuid === currentUserId);
  const otherBatches = batchesWithSortIndex.filter(({ assignedToGuid }) => assignedToGuid !== currentUserId);

  return {
    ...state,
    myBatches: normalizeBatches(myBatches),
    otherBatches: normalizeBatches(otherBatches),
    totalBatchesCount: totalCount,
    hasFetchedActiveBatches: true,
    isLoading: false,
  };
};

const actionHandlerMap = {
  [Actions.GET_BATCH_MENU_DATA]: (state) => {
    return {
      ...state,
      hasFetchedActiveBatches: false,
    };
  },
  [Actions.GET_BATCH_MENU_SUCCESS]: handleBatchMenuSuccess,
  [Actions.LOAD_MORE_ACTIVE_BATCHES]: (state) => {
    const { pageSize } = state;
    return {
      ...state,
      pageSize: pageSize + 25,
    };
  },
  [Actions.TOGGLE_BATCH_NAV_MENU]: (state) => {
    return {
      ...state,
      isMenuOpen: !state.isMenuOpen,
    };
  },
  [Actions.UPDATE_BATCH_NAV_NAME]: (state, { fulfillmentPlanSetId, name }) => {
    const { myBatches } = state;
    const updatedBatch = { ...myBatches[fulfillmentPlanSetId], name };
    return {
      ...state,
      myBatches: { ...myBatches, [fulfillmentPlanSetId]: updatedBatch },
    };
  },
  [BasicBatchActions.CANCEL_BATCH_REQUEST]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [BasicBatchActions.CLEAR_BATCH]: (state, { batchIds }) => {
    const { myBatches } = state;
    if (batchIds && batchIds.length) {
      const newMyBatches = Object.keys(myBatches).reduce((acc, batchId) => {
        if (batchIds.includes(batchId)) {
          return acc;
        }
        return {
          ...acc,
          [batchId]: myBatches[batchId],
        };
      }, {});
      return {
        ...state,
        isLoading: false,
        myBatches: newMyBatches,
      };
    }
    return { ...state };
  },
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './batches.nav.reducer.metadata';
